<div
  class="topbar"
  data-testid="topbar"
>
  <div>
    <figure>
      <!-- TODO: Parametrizar -->
      <!-- Logo da clínica -->
      <img
        src="assets/images/brand-logo-icon.svg"
        [alt]="translateService.getTranslation('OTIMUS4422')"
      />
    </figure>
    <app-search />
    <nav class="topbar-buttons">
      <!-- Mural de recados -->
      <button
        class="notifiable-btn"
        [title]="translateService.getTranslation('OTIMUS2946')"
      >
        <span class="material-symbols-outlined pin-animation"> keep </span>
        <!-- <oc-badge [ocWaved]="true">12</oc-badge> -->
      </button>
      <div class="divider"></div>
      <!-- Chat -->
      <button
        class="notifiable-btn"
        [title]="translateService.getTranslation('OTIMUS4428')"
        (click)="openChat()"
      >
        <span class="notifiable-icon material-symbols-outlined chat-animation"> chat_bubble </span>
        @if (chatState.totalUnread() > 0) {
          <oc-badge [ocWaved]="true">{{ chatState.totalUnread() }}</oc-badge>
        }
      </button>
    </nav>
  </div>
  <app-authenticated-user />
</div>

@if (chatOpen()) {
  <div
    class="chat-overlay"
    (click)="closeChat()"
  >
    <div
      class="chat-overlay-panel"
      (click)="$event.stopPropagation()"
    >
      <app-message-chat (closeChat)="closeChat()" />
    </div>
  </div>
}
